// Google Analytics 4 — single site-wide implementation.
// The Measurement ID comes from REACT_APP_GA4_MEASUREMENT_ID (frontend/.env).
// While the ID is empty, nothing is injected and no requests are made.
// SPA pattern: gtag loads with send_page_view disabled; every route change
// (including the first) sends exactly one page_view via gtag config.

const GA_ID = (process.env.REACT_APP_GA4_MEASUREMENT_ID || "").trim();

let initialized = false;
let lastTrackedPath = null;

export function initAnalytics() {
  if (!GA_ID || initialized || typeof document === "undefined") return;
  // Guard against any other copy of the gtag script ever being present
  if (document.querySelector('script[src*="googletagmanager.com/gtag/js"]')) {
    initialized = true;
    return;
  }
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(GA_ID)}`;
  document.head.appendChild(s);

  window.dataLayer = window.dataLayer || [];
  window.gtag = function () { window.dataLayer.push(arguments); };
  window.gtag("js", new Date());
  window.gtag("config", GA_ID, { send_page_view: false });
  initialized = true;
}

export function trackPageview() {
  if (!initialized || typeof window.gtag !== "function") return;
  const path = window.location.pathname + window.location.search;
  if (path === lastTrackedPath) return; // dedupe (StrictMode double-effect, repeated mounts)
  lastTrackedPath = path;
  window.gtag("config", GA_ID, {
    page_path: path,
    page_location: window.location.href,
    page_title: document.title,
  });
}

// ---- GA4 ecommerce events ----

export function trackEvent(name, params) {
  if (!initialized || typeof window.gtag !== "function") return;
  window.gtag("event", name, params);
}

/** GA4 item shape. item_id prefers SKU so every event reports the same product ID. */
export function gaItem(i) {
  return {
    item_id: i.sku || i.id || i.book_id,
    item_name: i.title,
    item_category: i.category || undefined,
    item_variant: i.format || undefined,
    price: Number(i.price) || 0,
    quantity: Number(i.quantity) || 1,
  };
}
